import { createApp } from 'vue'; // Vue 3 importation correcte
import App from './App.vue';     // Chemin vers le composant App
import router from './router';    // Si vous utilisez Vue Router
//import store from './store';      // Si vous utilisez Vuex

const app = createApp(App);
app.use(router);  // Utilisez Vue Router si nécessaire
//app.use(store);   // Utilisez Vuex si nécessaire
app.mount('#app');